/**************************************************
 * Nombre:       Tarjeta_Mesa_Vista_Diaria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, Typography} from "@mui/material";
import {ESTADOSRESERVAS} from "../../Constantes";
import {TableRestaurant} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
import {useCuentaRegresiva} from "../Componentes/useCuentaRegresiva";

const Tarjeta_Mesa_Vista_Diaria = ({item, reservas = [], click}) => {
    const [fechaSiguiente, setFechaSiguiente] = useState(dayjs().subtract(2, "hour"));
    const {Reloj} = useCuentaRegresiva({fecha: fechaSiguiente})
    const [reserMesa, setReserMesa] = useState([])
    const [resComples, setResComples] = useState([])
    const [openReservas, setOpenReservas] = useState(false)
    const [openComples, setOpenComples] = useState(false)


    const darColor = (estado) => {

        switch (estado) {
            case ESTADOSRESERVAS[1].nombre:
                return {
                    backgroundColor: theme.palette.primary.main
                }
        }
    }

    function obtenerFechaMenor(arr) {
        if (arr.length === 0) return null; // Validación por si el array está vacío

        return arr.reduce((masAntigua, itemActual) => {
            // Comparamos convirtiendo las fechas a milisegundos
            return itemActual.fecha < masAntigua.fecha ? itemActual : masAntigua;
        });
    }

    useEffect(() => {

        let arr = []
        let comple = []
        for (let i = 0; i < reservas.length; i++) {

            if (reservas[i].idMesa === item.id) {

                if (reservas[i].estado === ESTADOSRESERVAS[0].nombre) {
                    arr.push(reservas[i])
                } else if (reservas[i].estado === ESTADOSRESERVAS[1].nombre) {
                    comple.push(reservas[i])
                }


            }


        }

        let menor = obtenerFechaMenor(arr)
        console.log(menor)
        if (menor) {
            setFechaSiguiente(menor.fechaInicio)
        }


        setResComples(comple)
        setReserMesa(arr)

    }, [reservas])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                ...darColor(item.estado),
                borderRadius: 1,
                boxShadow: 4,
                p: 2
            }}
        >

            <Grid container size={{xs: 6, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 600, fontSize: 24}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 6, sm: 12, md: 6}} sx={{justifyContent: 'center'}}>
                <TableRestaurant sx={{width: 40, height: 40}}/>
            </Grid>


            <Grid
                onClick={() => setOpenReservas(!openReservas)}
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    p: 0.5,
                    px: 1,
                    borderRadius: 1,
                    mt: 2,
                    cursor: 'pointer'
                }}
            >

                <Grid container size={{xs: 10, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{color: '#fff', fontSize: 12}}>Reservas</Typography>
                </Grid>

                <Grid container size={{xs: 2, sm: 12, md: 2}} sx={{justifyContent: 'flex-end'}}>
                    <Typography sx={{color: '#fff', fontSize: 12}}>{reserMesa.length}</Typography>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Collapse in={openReservas} sx={{width: '100%'}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{mt: 1}}
                        spacing={1}
                    >


                        {reserMesa.map((res, index) => {
                            return (

                                <Grid
                                    onClick={() => click(res)}
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{
                                        border: 1,
                                        borderColor: theme.palette.primary.main,
                                        borderRadius: 1,
                                        p: 0.5,
                                        cursor: 'pointer'
                                    }}
                                >


                                    <Grid key={index + 'awe9'} container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{fontSize: 12}}>
                                            {'⋅ ' + res.nombre}
                                        </Typography>
                                    </Grid>

                                    <Grid key={index + 'awe9'} container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-end', mt: -1}}>
                                        <Typography sx={{fontSize: 12, fontWeight: 800}}>
                                            {dayjs(res.fechaInicio).format('HH:mm a')}
                                        </Typography>
                                    </Grid>


                                </Grid>
                            )
                        })}


                    </Grid>

                </Collapse>
            </Grid>

            <Grid
                onClick={() => setOpenComples(!openComples)}
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#00000080',
                    p: 0.5,
                    px: 1,
                    borderRadius: 1,
                    mt: 1

                }}
            >

                <Grid container size={{xs: 10, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{color: '#fff', fontSize: 12}}>Completadas</Typography>
                </Grid>

                <Grid container size={{xs: 2, sm: 12, md: 2}} sx={{justifyContent: 'flex-end'}}>
                    <Typography sx={{color: '#fff', fontSize: 12}}>{resComples.length}</Typography>
                </Grid>

            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Collapse in={openComples} sx={{width: '100%'}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{mt: 1}}
                        spacing={1}
                    >


                        {resComples.map((res, index) => {
                            return (

                                <Grid
                                    onClick={() => click(res)}
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{
                                        border: 1,
                                        borderColor: theme.palette.primary.main,
                                        borderRadius: 1,
                                        p: 0.5,
                                        cursor: 'pointer'
                                    }}
                                >


                                    <Grid key={index + 'awe9'} container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{fontSize: 12}}>
                                            {'⋅ ' + res.nombre}
                                        </Typography>
                                    </Grid>

                                    <Grid key={index + 'awe9'} container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-end', mt: -1}}>
                                        <Typography sx={{fontSize: 12, fontWeight: 800}}>
                                            {dayjs(res.fechaInicio).format('HH:mm a')}
                                        </Typography>
                                    </Grid>


                                </Grid>
                            )
                        })}


                    </Grid>

                </Collapse>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 12}}>Proxima Reserva</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 0}}>
                {reserMesa.length > 0 &&
                    <Reloj tamano={16} peso={600}/>
                }

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Mesa_Vista_Diaria